import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import { useStyles } from './styles';
import { generateInputParamsAttributesOptional } from '../constants';
import { useTableCellStyles } from '../../Card/styles';
import Accordion from '../../Accordion';

const OptionalParameters = ({ inputParameters }) => {
	const classes = useStyles();
	const tableCellClasses = useTableCellStyles();
	const INPUT_PARAMS_ATTRIBUTES_OPTIONAL = generateInputParamsAttributesOptional(inputParameters.supplyType);

	return (
		<Accordion
			variant="small"
			title="Optional"
			content={
				<Table className={classes.content}>
					<TableBody>
						{INPUT_PARAMS_ATTRIBUTES_OPTIONAL.map(attribute => (
							<TableRow key={attribute}>
								<TableCell classes={tableCellClasses}>
									<Typography variant="body2" color="textSecondary">
										{attribute.label + ':'}
									</Typography>
								</TableCell>

								<TableCell classes={tableCellClasses}>
									<Typography variant="body1">{inputParameters[attribute.value] + ' ' + attribute.unit}</Typography>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			}
		/>
	);
};

OptionalParameters.propTypes = {
	inputParameters: PropTypes.object.isRequired
};

export default OptionalParameters;
